import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://arenda.euromotorsufa.ru/api/'
});

export default instance; 